module.exports = __webpack_public_path__ + "static/media/arles_thermen_tn.84cd804f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/arles_thermen_tn.jpg
// module id = 708
// module chunks = 0